import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { CommonService } from 'app/Common/common.service';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { NotificationListComponent } from 'app/modules/notifications/notification-list/notification-list.component';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import * as signalR from "@microsoft/signalr";
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
/*import { AngularFireDatabase } from '@angular/fire/compat/database';*/
import { FuseNavigationItem } from '../../../../@fuse/components/navigation';
import { defaultNavigation } from '../../../mock-api/common/navigation/data';
import { NavigationService } from '../../../core/navigation/navigation.service';

@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'notifications',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, RouterLink, NotificationListComponent, TranslatePipe, RouterModule],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  @ViewChild('notificationsOrigin') private _notificationsOrigin: MatButton;
  @ViewChild('notificationsPanel') private _notificationsPanel: TemplateRef<any>;
  private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
  latestActivity = [];
  unreadActivityCount = 0;
  isAuto = false;
  private _overlayRef: OverlayRef;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _notificationsService: NotificationsService,
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef,
    private _commonService: CommonService,
    private _router: Router,
    public _matDialog: MatDialog,
   /* private db: AngularFireDatabase,*/
    private _navigationService: NavigationService,
  ) {

  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this._notificationsService.onActivityChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(response => {
        this.latestActivity = response != null ? response : [];

      });
    this._notificationsService.onActivityCountChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(response => {

        this.unreadActivityCount = response;
        this._changeDetectorRef.markForCheck();
      });
    if (this._commonService.admin_id > 0) {
      this._notificationsService.getNotificationUnreadCount(false);

    }

  }

  ngAfterViewInit() {
    this.ConnectHub();
  }
  /**

    /**
     * On destroy
     */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();

    // Dispose the overlay
    if (this._overlayRef) {
      this._overlayRef.dispose();
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Open the notifications panel
   */
  openPanel(): void {
    // Return if the notifications panel or its origin is not defined
    if (!this._notificationsPanel || !this._notificationsOrigin) {
      return;
    }

    // Create the overlay if it doesn't exist
    if (!this._overlayRef) {
      this._createOverlay();
    }

    // Attach the portal to the overlay
    this._overlayRef.attach(new TemplatePortal(this._notificationsPanel, this._viewContainerRef));

    this.latestActivity = [];

    this._notificationsService.getNotificationList(true);
  }

  /**
   * Close the notifications panel
   */
  closePanel(): void {
    this._overlayRef.detach();
  }




  ConnectHub() {


    let HubProxy = new signalR.HubConnectionBuilder()
      .withUrl(environment.signal_r_hub + 'signalr').withAutomaticReconnect()
      .build();

    HubProxy
      .start()
      .then(() => { console.log('Connection started'); })
      .catch(err => console.log('Error while starting connection: ' + err));


    let data_update_start = true;
    HubProxy.on("client_portal_access_updated", (admin_id, client_id) => {

      if (data_update_start == true && this._commonService.admin_id == admin_id && this._commonService.client_id == client_id) {

        data_update_start = false;
        this._commonService.getUserByToken(); 
      }
    });
  }

  getPageName() {
    var url = this._router.url;
    var arrayUrlSegments = url.split('/');
    return arrayUrlSegments[1];
  }



  Notify(message, NotificationTitle, url) {
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification");
    }
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
    else {
      var notification = new Notification(NotificationTitle, {
        body: message,
        icon: environment.base_url + "/assets/icons/custom/notification-icon.png"
      });
      notification.onclick = function () {
        window.open(environment.base_url + "/" + url + "/");
      };
    }
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Create the overlay
   */
  private _createOverlay(): void {
    // Create the overlay
    this._overlayRef = this._overlay.create({
      hasBackdrop: true,
      backdropClass: 'fuse-backdrop-on-mobile',
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy: this._overlay.position()
        .flexibleConnectedTo(this._notificationsOrigin._elementRef.nativeElement)
        .withLockedPosition(true)
        .withPush(true)
        .withPositions([
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
          },
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
          },
        ]),
    });

    // Detach the overlay from the portal on backdrop click
    this._overlayRef.backdropClick().subscribe(() => {
      this._overlayRef.detach();
    });
  }
}
